<template>
    <div class="slp-footer">
        <div class="slp-footer-info">
            <div class="photo">
                <img :src="logoImg" alt="" />
            </div>
            <div class="text">
                <span>|</span><strong>安全稳定的信贷数据管理</strong>
            </div>
        </div>
        <div class="slp-footer-text">
            <p>Powered By Creditloan System @ 2019-{{currDate}} Inc. Global</p>
            <p>Current Version:Creditloan System 2.1</p>
        </div>
    </div>
</template>

<script>
import moment from 'moment-timezone'
export default {
    name:"vFooter",
    data(){
        return{
            logoImg:require('@/assets/logo-footer.png'),
            currDate:moment().format("YYYY"),
        }
    },
    methods:{

    },
    components:{

    },
    mounted(){

    }
}
</script>



// WEBPACK FOOTER //
// src/layouts/components/vFooter.vue